

export default class MeveoClient {
	constructor(datum, createCRMAccountHierarchy) {
		if (createCRMAccountHierarchy) {
			this.crmAccountType = datum.accountType || "Client";
			this.crmParentCode = seller;
			this.code = datum.userName;
		} else {
			this.crmAccountType = datum.accountType || "CA_UA";
			this.crmParentCode = datum.userName;
			this.code = datum.code;
		}
			this.description = (!!datum.firstName || !!datum.lastName) ? datum.firstName + " " + datum.lastName : (datum.description || "customer description");
			this.name = {
				"title": datum.title || "",
				"firstName": datum.firstName,
				"lastName": datum.lastName
			};
			this.address = {
				"address1": datum.address1 || "",
				"address2": datum.address2 || "",
				"address3": datum.address3 || "",
				"zipCode": datum.zipCode || "",
				"city": datum.city || "",
				"country": datum.country || "",
				"state": datum.state || ""
			};
			this.contactInformation = {
				"email": datum.email,
				"phone": datum.phone,
				"mobile": datum.mobile
			};
			this.language = datum.language || 'FRA';
			this.customerCategory = datum.accountType || "Client";
			this.currency = 'EUR';
			this.caStatus = 'ACTIVE';
			this.billingCycle = datum.billingCycle || billing_cycle;
			this.country = "FR";
			this.baStatus = 'ACTIVE';
			this.email = datum.billingEmail || '';
			this.uaStatus = 'ACTIVE';
			this.electronicBilling = datum.electronicBilling || false;
			this.customFields = {
				"customField": [
					{
						"code": "password",
						"stringValue": datum.password
					}
				]
			};
		}

	static convertFromProperties(entity) {
		return new MeveoCustomer(entity);
	}

	get meveoJson() {
		return JSON.stringify(this);
	}

}



// WEBPACK FOOTER //
// ./src/opencell/model/MeveoClient.js